import { useState, useEffect } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import Addicon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ButtonGroup from "@mui/material/ButtonGroup";
import { Button as UIButton } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { Text, useFormContext } from "$components";
import { theme } from "$utils/theme/bataillog";

interface InputType {
  value?: string;
  errorRegex?: boolean;
  errorRequired?: boolean;
  disabled?: boolean;
}

function NumberInputWithIncDecBtn({
  label,
  name,
  requiredText,
  errorRequired = false,
}: any) {
  const context = useFormContext();
  const { values, setFormValues } = context;
  const [error, setError] = useState<string>("");
  const classes = useStyles();

  const onAdd = () => {
    const prev = parseInt(values[name]?.value || "0", 10);
    const val = prev + 1;
    setStateValue({
      value: val.toString(),
      errorRegex: false,
      errorRequired: false,
    });
  };

  const onSubstract = () => {
    const prev = parseInt(values[name]?.value || "0", 10);
    const val = prev > 0 ? prev - 1 : 0;
    setStateValue({
      value: val.toString(),
      errorRegex: false,
      errorRequired: false,
    });
  };

  useEffect(() => {
    if (errorRequired) {
      setError(requiredText || "");
    }
  }, [errorRequired, requiredText]);

  const setStateValue = (dataInput: InputType) => {
    const newValue = {
      ...values[name],
      ...dataInput,
    };
    setFormValues({
      [name]: newValue,
    });
  };

  const OnChange = (e: any) => {
    const val = e?.target?.value || "";
    setError("");
    setStateValue({
      value: val,
      errorRegex: false,
      errorRequired: false,
    });
  };

  useEffect(() => {
    if (errorRequired) {
      setError(requiredText || "");
    }
  }, [errorRequired, requiredText]);

  return (
    <div className={classes.Container}>
      {label && (
        <label className={classes.inputLabel} htmlFor={name}>
          <Text>{label}</Text>
        </label>
      )}
      <ButtonGroup
        className={classes.InputNumberContainer}
        disableElevation
        variant="outlined"
      >
        <UIButton onClick={onSubstract}>
          <RemoveIcon />
        </UIButton>
        <InputBase
          type="number"
          name={name}
          inputProps={{
            min: "0",
            step: "1",
            style: { textAlign: "center", background: "#fff" },
          }}
          className={classes.inputClass}
          value={values[name]?.value}
          onChange={OnChange}
        />
        <UIButton className={classes.lastBtn} onClick={onAdd}>
          <Addicon />
        </UIButton>
      </ButtonGroup>
      <Text className={classes.errorField}>{error !== "" && error}</Text>
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  Container: {
    display: "flex",
    flexDirection: "column",
  },
  inputClass: {
    borderTop: "solid 1px rgb(0,0,0,0.2)",
    borderBottom: "solid 1px rgb(0,0,0,0.2)",
  },
  lastBtn: {
    borderLeft: "none !important",
  },
  add: {
    marginTop: "5px !important",
  },
  inputLabel: {
    marginBottom: "16px",
  },
  InputNumberContainer: {
    height: 45,
    border: `1px ${theme.color.gray2}`,
    borderStyle: "none",
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
}));

export default NumberInputWithIncDecBtn;
